import React from 'react';
import AppAdminListItem from "./AppAdminListItem.mjs";

export default function AppAdminList({user_id}) 
{
    if (user_id != 'USER#sstawar') return;

    return ( <> <AppAdminListItem display_type="user-app-admin-display" /> </> );
}